$("#ajax-sample-code-confirm").on("click", function() {
  $.ajax({
    type: "GET",
    url: "http://localhost:3000/regist?code=" + $("#ajax-sample-code").val(),
    success: function(results) {
      if(results.length > 0) {
        $("#ajax-sample-checkin").removeClass("is-disable")
        $("#ajax-sample-code-name").text(results[0].name)
        $("#ajax-sample-code-kana").text(results[0].kana)
        $("#ajax-sample-code-company").text(results[0].company)
      } else {
        $("#ajax-sample-checkin").addClass("is-disable")
        $("#ajax-sample-code-name").text("")
        $("#ajax-sample-code-kana").text("")
        $("#ajax-sample-code-company").text("")
      }
    },
    error: function() {
      alert("ユーザ情報の取得に失敗しました。")
    }
  });
})

$("#ajax-sample-checkin").on("click", function() {
  $.ajax({
    type: "POST",
    url: "http://localhost:3000/checkin",
    contentType: "application/json",
    data: JSON.stringify({code: []}),
    success: function(results) {
      $("#ajax-sample-code").val("");
    },
    error: function() {
      alert("登録者情報の登録に失敗しました。");
    }
  });
});
